import {
  Avatar,
  Card,
  CardContent,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListSubheader,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import Search from "../../common/Search/Search";
import { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiService from "../../modules/APIService.interceptors";
import { useRef } from "react";

const CardWorkshopUsers = (height, width) => {
  const [users, setUsers] = useState([]);
  const { workshopId } = useParams();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const limit = 50;
  const listRef = useRef();

  const getUsers = async (nextPage = 1) => {
    if (loader || !hasMore) return;
    setLoader(true);
    try {
      const response = await ApiService.getUsersWorkshop(workshopId, nextPage, limit);
      const fetchedUsers = response.data[0];

      if (!response.error && fetchedUsers.length > 0) {
        setUsers(prev => [...prev, ...fetchedUsers]);
        setFilteredUsers(prev => [...prev, ...fetchedUsers]);
        setPage(nextPage);
        if (fetchedUsers.length < limit) setHasMore(false); // No hay más páginas
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error(error);
      setHasMore(false);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getUsers(1);
  }, [workshopId]);

  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchText(value);

    if (value.trim() === "") {
      // Si no hay texto de búsqueda, mostrar todos los usuarios
      setFilteredUsers(users);
    } else {
      // Filtrar usuarios según el texto de búsqueda
      const lowercasedFilter = value.toLowerCase();
      const filtered = users.filter(
        (user) =>
          user?.name.toLowerCase().includes(lowercasedFilter) ||
          user?.lastname.toLowerCase().includes(lowercasedFilter)
      );
      setFilteredUsers(filtered);
    }
  };

  return (
    <Card sx={{ width: width, height: height }}>
      <CardContent>
        <Typography>Lista de Sirenas</Typography>
        <Divider />

        <ListSubheader
          sx={{
            fontWeight: "bold",
            bgcolor: "background.paper",
            paddingY: "2%",
          }}
        >
          <Grid container alignItems="center">
            <Grid item xs={1}>
              <Typography variant="body2" fontWeight="bold"></Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="body2" fontWeight="bold">
                Nombre y Apellido
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" fontWeight="bold">
                DNI
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" fontWeight="bold">
                Email
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" fontWeight="bold">
                Dirección
              </Typography>
            </Grid>
          </Grid>
        </ListSubheader>

        <Search
          setSearchText={setSearchText}
          searchText={searchText}
          handleSearchChange={handleSearchChange}
          filter={"nombre"}
          select={false}
        />

        {/* Mostrar Loader si está cargando */}
        {loader ? (
          <Box py={2} display="flex" justifyContent="center">
            <CircularProgress size={24} />
          </Box>
        ) : (
          <List
            ref={listRef}
            onScroll={(e) => {
              const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
              const isBottom = scrollTop + clientHeight >= scrollHeight - 50;
              if (isBottom && !loader && hasMore) {
                getUsers(page + 1);
              }
            }}
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              height: 500,
              overflow: "auto",
              boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
              mt: 2,
            }}
          >
            {filteredUsers?.map((user, index) => (
              <Fragment key={index}>
                <ListItem>
                  <Grid container alignItems="center">
                    <Grid item xs={1}>
                      <ListItemAvatar>
                        <Avatar src={user?.avatar} />
                      </ListItemAvatar>
                    </Grid>
                    <Grid item xs={3}>
                      <ListItemText
                        onClick={() => navigate(`/usuarios/${user?.id}`)}
                        primary={
                          <Typography
                            sx={{
                              cursor: "pointer",
                              "&:hover": {
                                textDecoration: "underline",
                                color: "grey",
                              },
                            }}
                          >
                            {user?.name} {user?.lastname}
                          </Typography>
                        }
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        sx={{ color: "gray", fontSize: 14, fontWeight: 200 }}
                      >
                        {user?.dni}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        sx={{ color: "gray", fontSize: 14, fontWeight: 200 }}
                      >
                        {user?.email}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography
                        sx={{ color: "gray", fontSize: 14, fontWeight: 200 }}
                      >
                        {user?.user_location}
                      </Typography>
                    </Grid>
                  </Grid>
                </ListItem>
                <Divider component="li" />
              </Fragment>
            ))}
          </List>
        )}
      </CardContent>
    </Card>
  );
};

export default CardWorkshopUsers;
